import JsonView from 'react18-json-view';
import './style.css';

export default JsonView